import {from, mergeMap, Observable, of} from "rxjs";
import {UserModel} from "../models/user";
import {UserApi} from "../apis/userApi";
import {SetContactInfoPayload} from "../models/setContactInfoPayload";
import FingerprintJS from '@fingerprintjs/fingerprintjs-pro'
import {FitnessProfileModel} from "../models/fitnessProfile";
import {OnboardingLinkResponseModel} from "../models/onboardingLinkResponse";

let deviceFingerprint: string;

export const UserService = {
  fetchUser(): Observable<UserModel | null> {
    // Backend is the source of truth; /user/me returns a full UserModel.
    return UserApi.getUser()
  },
  fetchOnboardingLink(): Observable<OnboardingLinkResponseModel> {
    return UserApi.getOnboardingLink()
  },
  updateAppReferrer(referrer: string): Observable<void> {
    return UserApi.updateAppReferrer(referrer)
  },
  updateContactInfo(payload: SetContactInfoPayload): Observable<UserModel | null> {
    return UserApi.setContactInfo(payload)
      .pipe(mergeMap(() => UserApi.getUser()))
  },
  updateFitnessProfile(_fitnessProfile: FitnessProfileModel): Observable<void> {
    // Fitness profile is persisted to the backend by the macro survey submission
    // (POST /user/save-survey); the previous Realm write is no longer needed.
    return of(undefined)
  },
  getDeviceFingerprint(): Observable<string> {
    const fpPromise = FingerprintJS.load({
      token: process.env.NEXT_PUBLIC_FINGERPRINT_JS_TOKEN!,
      endpoint: process.env.NEXT_PUBLIC_FINGERPRINT_JS_DOMAIN
    })

    if (deviceFingerprint) return of(deviceFingerprint)

    return from(fpPromise.then(fp => fp.get()).then(result => {
      deviceFingerprint = result.visitorId
      return result.visitorId
    }))
  }
}